module.exports = __webpack_public_path__ + "static/images/info.3vp2zJV.svg";